import { useRef, useState, type CSSProperties } from 'react';
import { useVisibleSampleVideo } from './use-visible-sample-video';

/** One contained, user-started sample player shared by the format and map galleries. */
export function SampleVideoPlayer({ src, width, height, label, description, playbackRate = 1 }: {
  src: string; width: number; height: number; label: string; description: string; playbackRate?: number;
}) {
  const [failed, setFailed] = useState(false);
  const video = useRef<HTMLVideoElement>(null);
  const playbackSrc = `${src}#t=0.001`;
  useVisibleSampleVideo(video, playbackSrc);
  return <div className="sample-video" style={{ '--sample-aspect-ratio': width / height } as CSSProperties}>
    <div className="sample-player">
      <video ref={video} data-public-sample controls playsInline preload="metadata" muted width={width} height={height}
        aria-label={description}
        onLoadedMetadata={event => {
          event.currentTarget.defaultPlaybackRate = playbackRate;
          event.currentTarget.playbackRate = playbackRate;
        }}
        onPlay={() => {
          document.querySelectorAll<HTMLVideoElement>('video[data-public-sample]').forEach(other => { if (other !== video.current) other.pause(); });
          setFailed(false);
        }}
        onError={() => setFailed(true)}>
        <a href={src}>Watch the {label} sample</a>
      </video>
      {failed && <p role="alert">The sample could not load. <a href={src}>Open the video directly</a>.</p>}
    </div>
  </div>;
}
